import axios, { AxiosInstance } from 'axios';

const API_SECRET = process.env.NEXT_PUBLIC_API_SECRET || '';

async function sign(ts: string): Promise<string> {
    const enc = new TextEncoder();
    const key = await crypto.subtle.importKey(
        'raw',
        enc.encode(API_SECRET),
        { name: 'HMAC', hash: 'SHA-256' },
        false,
        ['sign'],
    );
    const buf = await crypto.subtle.sign('HMAC', key, enc.encode(ts));
    return Array.from(new Uint8Array(buf))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
}

const axiosInstance: AxiosInstance = axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_URL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
});

axiosInstance.interceptors.request.use(async (config) => {
    const ts = Date.now().toString();
    const sig = await sign(ts);
    config.headers.set('X-Timestamp', ts);
    config.headers.set('X-Signature', sig);
    return config;
});

export default axiosInstance;
